<div
  *ngIf="gridApi.getSelectedNodes().length >= 1"
  class="grid-wrapper-checkbox"
  [ngClass]="{
    'checkbox--intermediate': gridApi.getSelectedNodes().length >= 1
  }"
>
  <input class="grid-input" type="checkbox" id="1" (change)="onSelectAll()" />
  <label for="1"></label>
</div>
